import { Model } from 'infra/model'
import { WorkspaceWithInventoryItems as WorkspaceWithInventoryItemsProto } from '@taxfyle/api-internal/internal/inventory_item_pb'
import { computed, observable, makeObservable } from 'mobx'
import WorkspaceStore from 'iam/WorkspaceStore'
import Workspace from 'iam/models/Workspace'

export default class WorkspaceWithInventoryItems extends Model<
  WorkspaceWithInventoryItemsProto.AsObject,
  WorkspaceWithInventoryItems
> {
  @observable workspaceId = ''
  @observable total = 0

  constructor(private workspaceStore: WorkspaceStore) {
    super()
    makeObservable(this)
  }

  @computed
  get workspace() {
    return (
      this.workspaceStore.workspaces.get(this.workspaceId) || Workspace.none
    )
  }

  parse(
    json: Partial<WorkspaceWithInventoryItemsProto.AsObject>,
  ): Partial<WorkspaceWithInventoryItems> {
    this.workspaceStore.fetch(json.workspaceId)

    return {
      total: json.total,
      workspaceId: json.workspaceId,
    }
  }
}
